import React, { useState, useEffect, useRef } from 'react';
import styles from '../../styles/components/Recommendations.module.css';
import featuredItems from '../../recommendations/featuredItem';
import FeaturedDetails from './FeaturedDetails';

function Recommendations() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedFeatured, setSelectedFeatured] = useState(null);
  const [isPaused, setIsPaused] = useState(false);
  const timeoutRef = useRef(null);
  const delay = 3000; // ms

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === featuredItems.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? featuredItems.length - 1 : prevIndex - 1
    );
  };
  
  const openFeaturedDetail = (index) => {
    setSelectedFeatured(featuredItems[currentIndex]);
    setIsPaused(true);
  };

  const closeFeaturedDetail = () => {
    setIsPaused(false);
    setSelectedFeatured(null);
  };

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    if (!isPaused) {
      resetTimeout();
      timeoutRef.current = setTimeout(
        () => setCurrentIndex((prevIndex) =>
          prevIndex === featuredItems.length - 1 ? 0 : prevIndex + 1
        ),
        delay
      );
    }
  
    return () => {
      resetTimeout();
    };
  }, [currentIndex, isPaused]);


  return (
    <section id="recommendations" className={styles.recommendationsSection}>
      <h2 className={styles.sectionTitle}>Recommendations</h2>
      <div className={styles.description}>
        <p>Discover some of our favorite recommendations! From toys to travel accessories to home decor, each item helped make a magic memory for our family.</p>
      </div>
      <div 
        className={styles.carouselContainer}
        onMouseEnter={resetTimeout}
        onMouseLeave={() => {
          resetTimeout();
          timeoutRef.current = setTimeout(nextSlide, delay);
        }}
      >
        <button className={`${styles.navButton} ${styles.prevButton}`} onClick={prevSlide}>&#10094;</button>
        <div className={styles.carousel}>
          {featuredItems.map((item, index) => (
            <div
              key={item.id}
              className={`${styles.slide} ${index === currentIndex ? styles.active : ''}`}
              onClick={() => openFeaturedDetail(currentIndex)}
            >
              <img src={item.slideImage} alt={item.slideTitle} className={styles.featuredImage} />
              <div className={styles.featuredName}>{item.slideTitle}</div>
            </div>
          ))}
        </div>
        <button className={`${styles.navButton} ${styles.nextButton}`} onClick={nextSlide}>&#10095;</button>
      </div>
      {selectedFeatured && (
        <div className={styles.featuredDetailOverlay} onClick={closeFeaturedDetail}>
          <div className={styles.featuredDetailContent} onClick={(e) => e.stopPropagation()}>
            <FeaturedDetails featured={selectedFeatured} onClose={closeFeaturedDetail} />
          </div>
        </div>
      )}
      <div className={styles.disclaimer}>
        <p><strong>Disclaimer:</strong> These are affiliate links, meaning we will get a small commission at no cost to you if you make a purchase using our links. Unless stated otherwise, none of these products are paid endorsements or sponsorships from the product companies. We only want to share products that we have used or made ourselves, and would happily recommend to our friends and family.</p>
      </div>
    </section>
  );
}

export default Recommendations;